































import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  CombinedClaimReceiptStatus,
  HsabExpenseOriginator,
  HsabExpenseReimbursementResponse,
  HsabExpenseResponse,
  HsabSsoDestination,
  WexExpenseAccountType
} from "@/shared/types";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    }
  },
  components: {
    GenericLoadingSpinner,
    SsoDeepLink,
    HsabExpenseEvidence,
    Pill,
    CurrencyAmount
  }
})
export default class HsabExpenseCardRowExpenseEvidence extends Vue {

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  @Prop({ required: true })
  reimbursement: HsabExpenseReimbursementResponse;

  @Prop({ required: true })
  expenseCategory: WexExpenseAccountType;

  @Prop()
  stagedFilesForUpload;

  @Prop({ default: false })
  isUploadingFilesToSubmittedExpense;

  managedExpenseStore = useManagedExpenseStore();
  hsabAccountsStore = useHsabAccountsStore();

  created () {
    this.hsabAccountsStore.getHsabAccounts();
    this.managedExpenseStore.loadUserHasHealthPlanExpense();
  }

  get uploadFileCount () {
    let count = 0;
    if (this.expense && this.expense.expenseEvidence) {
      count += this.expense.expenseEvidence.length;
    }
    if (this.stagedFilesForUpload) {
      count += this.stagedFilesForUpload.length;
    }
    return count;
  }

  get isExpenseSubmitted (): boolean {
    return this.expense && this.expense.isSubmitted;
  }

  get isExpenseSubmittedToHsa (): boolean {
    return this.expense &&
        this.expense.isSubmitted &&
        this.expense.reimbursement &&
        this.expense.reimbursement.isHsaReimbursement;
  }

  get isAddingReceiptsAllowed () {
    if (!this.expense) {
      return true;
    }
    return this.expense.isFileUploadAllowed;
  }

  get showButtonForReceiptNeeded () {
    return this.expense &&
        this.expense.originator === HsabExpenseOriginator.DebitCard &&
        this.expense.reimbursement &&
        this.expense.reimbursement.claimReceiptStatus === CombinedClaimReceiptStatus.ReceiptNeeded &&
        this.managedExpenseStore.userHasHealthPlanExpense &&
        this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }

  addFiles (files) {
    this.$emit("staged-files-updated", files);
  }

  handleAddFilesAfterSubmitted () {
    this.$emit("stage-files-submitted");
  }

}
